import { FC } from "react"
import { IconProps } from "@/components/shared/Icon"

const CalendarIcon: FC<IconProps> = ({ ...props }) => {
   return (
      <svg
         viewBox="0 0 22 24"
         fill="none"
         {...props}
      >
         <path
            d="M7.46,1.12c0-.62-.53-1.12-1.18-1.12s-1.18.5-1.18,1.12v1.88h-1.96c-1.73,0-3.14,1.35-3.14,3v15c0,1.65,1.41,3,3.14,3h15.71c1.73,0,3.14-1.35,3.14-3V6c0-1.65-1.41-3-3.14-3h-1.96v-1.88c0-.62-.53-1.12-1.18-1.12s-1.18.5-1.18,1.12v1.88h-7.07v-1.88ZM2.36,9h17.29v12c0,.41-.35.75-.79.75H3.14c-.43,0-.79-.34-.79-.75v-12Z"
            fill="currentColor"
         />
      </svg>
   )
}

export default CalendarIcon
